import React from 'react'
import { Attr } from './style'
import _ from 'lodash'
import { useIntl } from 'react-intl'

const ItemAttributes = ({
	attributes = {},
	size,
	isShowOnMobile,
	isOrdersPage,
	reclamationType,
	...props
}) => {
	let intl = useIntl()
	return (
		!_.isEmpty(attributes) && (
			<Attr
				reclamationType
				size={size}
				isShowOnMobile={isShowOnMobile}
				isOrdersPage={isOrdersPage}
				{...props}
			>
				{Object.values(attributes)?.map((item, idx) => (
					<div key={idx}>{`${intl.formatMessage({
						id: `changeProduct.attribute.${item.label}`,
						defaultMessage: item.label,
					})}: ${item.value}`}</div>
				))}
			</Attr>
		)
	)
}

export default ItemAttributes
